<template>
  <div id="wrapper" class="content image-main">
    <div style="position:absolute; top:0; left:50%; bottom:40px; transform: translateX(-50%);">
      <h3>
        以图搜图
      </h3>
    </div>
    <image-table />
  </div>
</template>

<script>
import { MessageBox, Message } from 'element-ui'
import ImageTable from '@/components/image-table'

export default {
  name: 'CommonImage',
  components: { ImageTable },
  data() {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/assets/styles/base";
  #wrapper h1 {
    margin: 1rem 0rem;
  }

  .content {
    margin: 0 auto;
    text-align: left;
  }

  .image-main {
    box-sizing: border-box;
    height: 100%;
    padding: 32px 0px 0px 0px;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/searchPage.vue